//custom action for checking whether context widget is part of the corporate site
export function isCorporate(widgetId) {
    return (dispatch, getState) => {
        const endpoint = getState().getIn(["config", widgetId, "endpoint"]) || "";
        return endpoint.includes("corp");
    };
}
